/* eslint-disable import/prefer-default-export */
import enUSIntl from 'antd/es/locale/en_US';
import esESIntl from 'antd/es/locale/es_ES';

export const locales = {
  es: esESIntl,
  en: enUSIntl,
};
